import { sampleType } from '@/domain/enums/sample';
import { timezones } from '@/constants/localizer';

const rangeRn9 = { min: 0, max: 1000000 };
const rangeRoomTemperature = { min: -30, max: 50 };
const rangeSampleTemperature = { min: -30, max: 200 };
const percentRangeRn9 = { min: 0, max: 100 };

export default {
  fields(vm) {
    return {
      primaryFields: [
        {
          model: 'h2',
          label: 'fields.engineering.chromatography.insert-sample.h2',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'cH4',
          label: 'fields.engineering.chromatography.insert-sample.ch4',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'c2H6',
          label: 'fields.engineering.chromatography.insert-sample.c2h6',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'c2H4',
          label: 'fields.engineering.chromatography.insert-sample.c2h4',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'c2H2',
          label: 'fields.engineering.chromatography.insert-sample.c2h2',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'co',
          label: 'fields.engineering.chromatography.insert-sample.co',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'cO2',
          label: 'fields.engineering.chromatography.insert-sample.co2',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'n2',
          label: 'fields.engineering.chromatography.insert-sample.n2',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'o2',
          label: 'fields.engineering.chromatography.insert-sample.o2',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          required: true,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'defaultAnalyticalDetectionLimit',
          label:
            'fields.engineering.chromatography.insert-sample.standard-analytical-detection-limit',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: 1,
          maxValue: rangeRn9.max,
          type: 'text',
          number: 1,
          cols: '12',
          sm: '6',
          xl: '6',
          placeholder: 'engineering.chromatography.default-number',
          tooltip:
            'fields.engineering.chromatography.insert-sample.standard-analytical-tooltip-message',
          precision: 1,
          inputOptions: {
            range: {
              min: 1,
              max: rangeRn9.max,
            },
            maxLength: 11,
          },
        },
        {
          model: 'accuracyFactor',
          label:
            'fields.engineering.chromatography.insert-sample.accuracy-factor',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: 10,
          maxValue: rangeRn9.max,
          type: 'text',
          number: 10,
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: 'engineering.chromatography.default-number',
          tooltip: null,
          precision: 1,
          inputOptions: {
            range: {
              min: 10,
              max: rangeRn9.max,
            },
            maxLength: 11,
          },
        },
      ],
      secondaryFields: [
        {
          model: 'analyticalDetectionLimitH2',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'H₂',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'analyticalDetectionLimitCH4',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'CH₄',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'analyticalDetectionLimitC2H6',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'C₂H₆',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'analyticalDetectionLimitC2H4',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'C₂H₄',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'analyticalDetectionLimitC2H2',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'C₂H₂',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'analyticalDetectionLimitCO',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'CO',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'analyticalDetectionLimitCO2',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'CO₂',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'analyticalDetectionLimitN2',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'N₂',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
        {
          model: 'analyticalDetectionLimitO2',
          label:
            'fields.engineering.chromatography.insert-sample.analytical-detection-limit',
          textParams: {
            chemicalElement: 'O₂',
          },
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRn9.min,
          maxValue: rangeRn9.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            rangeRn9,
            maxLength: 11,
          },
        },
      ],
      extraFields: [
        {
          model: 'roomTemperature',
          label:
            'fields.engineering.chromatography.insert-sample.ambient-temperature',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeRoomTemperature.min,
          maxValue: rangeRoomTemperature.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            temperatureRange: rangeRoomTemperature,
            maxLength: 3,
          },
        },
        {
          model: 'sampleTemperature',
          label:
            'fields.engineering.chromatography.insert-sample.sample-temperature',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: rangeSampleTemperature.min,
          maxValue: rangeSampleTemperature.max,
          type: 'text',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            temperatureRange: rangeSampleTemperature,
            maxLength: 3,
          },
        },
        {
          model: 'sampleType',
          label: 'fields.engineering.chromatography.insert-sample.sample-type',
          textParams: null,
          inputComponent: 's-select',
          cols: '12',
          sm: '6',
          xl: '6',
          placeholder: '',
          options: [
            {
              value: null,
              text: vm.$t('multiselect.placeholder'),
            },
            {
              value: sampleType.NEW,
              text: vm.$t('engineering.physical-chemical.new-oil-sample'),
            },
            {
              value: sampleType.USED,
              text: vm.$t('engineering.physical-chemical.used-oil-sample'),
            },
            {
              value: sampleType.REGENERATED,
              text: vm.$t(
                'engineering.physical-chemical.regenerated-oil-sample',
              ),
            },
            {
              value: sampleType.RECONDICIONED,
              text: vm.$t(
                'engineering.physical-chemical.recondicioned-oil-sample',
              ),
            },
          ],
          tooltip: null,
        },
        {
          model: 'analyzeDate',
          label:
            'fields.engineering.chromatography.insert-sample.analysis-date',
          textParams: null,
          inputComponent: 's-input-date-picker',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
          timeZone: timezones.UTC,
        },
        {
          model: 'analyzeTime',
          label:
            'fields.engineering.chromatography.insert-sample.analysis-time',
          textParams: null,
          inputComponent: 's-input-time',
          cols: '12',
          sm: '6',
          xl: '3',
          placeholder: '',
          tooltip: null,
        },
        {
          model: 'sampleLocation',
          label:
            'fields.engineering.chromatography.insert-sample.transformer-oil-sampling-location',
          textParams: null,
          inputComponent: 'b-form-input',
          maxLength: 500,
          cols: '12',
          sm: '6',
          xl: '6',
          placeholder: '',
          tooltip: null,
        },
        {
          model: 'airRelativeHumidity',
          label:
            'fields.engineering.chromatography.insert-sample.air-relative-humidity',
          textParams: null,
          inputComponent: 's-number-input',
          validation: true,
          minValue: percentRangeRn9.min,
          maxValue: percentRangeRn9.max,
          type: 'text',
          cols: '12',
          xl: '3',
          placeholder: '',
          tooltip: null,
          precision: 1,
          inputOptions: {
            percentRangeRn9,
            maxLength: 5,
          },
        },
        {
          model: 'observation',
          label: 'fields.general.observations',
          textParams: null,
          maxLength: 500,
          inputComponent: 'b-form-textarea',
          cols: '12',
          placeholder: '',
          tooltip: null,
        },
      ],
    };
  },
};
